var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTable',{attrs:{"shipmentCode":_vm.shipmentCode,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }